import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { AllocationStatus } from './SwipeableServiceCard.props';
import { COLORS } from '../../../../../configs/colors';

interface CardContainerProps {
  allocationStatus: AllocationStatus;
}

export const CardContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'allocationStatus',
})<CardContainerProps>(({ allocationStatus }) => ({
  background: COLORS.White,
  borderRadius: '16px',
  boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)',
  overflow: 'hidden',
  position: 'relative',
  transition: 'transform 0.2s ease',
  cursor: 'pointer',
  margin: '4px 16px',
  borderLeft:
    allocationStatus === 'currentUser'
      ? `5px solid ${COLORS.NavyBlue}`
      : allocationStatus === 'unallocated'
        ? `5px solid ${COLORS.SoftRed}`
        : `5px solid ${COLORS.MediumGrey}`,
  '&:active': {
    transform: 'scale(0.98)',
  },
}));

export const SlideContainer = styled(Box)({
  overflow: 'hidden',
  position: 'relative',
  userSelect: 'none',
});

export const SlideTrack = styled(Box)({
  display: 'flex',
  transition: 'transform 0.35s cubic-bezier(0.32, 0.72, 0, 1)',
  willChange: 'transform',
});

export const Slide = styled(Box)({
  flex: '0 0 100%',
  minWidth: 0,
  padding: '8px 12px',
  boxSizing: 'border-box',
  overflow: 'hidden',
});

export const DotsContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  gap: '5px',
  padding: '4px 0',
});

interface DotProps {
  active?: boolean;
}

export const Dot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active',
})<DotProps>(({ active }) => ({
  width: active ? '14px' : '5px',
  height: '5px',
  borderRadius: active ? '2.5px' : '50%',
  background: active ? COLORS.NavyBlue : COLORS.LightGrey,
  opacity: active ? 1 : 0.25,
  transition: 'all 0.25s ease',
}));

export const BadgeRowContainer = styled(Box)({
  display: 'flex',
  gap: '6px',
  padding: '0 14px 8px',
});

interface BadgeProps {
  badgeVariant: 'unallocated' | 'breached';
}

export const Badge = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'badgeVariant',
})<BadgeProps>(({ badgeVariant }) => ({
  fontWeight: 600,
  fontSize: '0.6rem',
  textTransform: 'uppercase',
  letterSpacing: '0.8px',
  padding: '4px 10px',
  borderRadius: '50px',
  ...(badgeVariant === 'unallocated' && {
    background: `${COLORS.PriorityP3}14`,
    color: COLORS.PriorityP3,
  }),
  ...(badgeVariant === 'breached' && {
    background: `${COLORS.SLABreached}14`,
    color: COLORS.SLABreached,
    '@keyframes pulseGlow': {
      '0%, 100%': { opacity: 1, boxShadow: 'none' },
      '50%': { opacity: 0.7, boxShadow: `0 0 8px ${COLORS.SLABreached}4D` },
    },
    animation: 'pulseGlow 2s infinite',
  }),
}));
